import Animation from "@/components/careers/Animation";
import ClientTestimonialSlider from "@/components/careers/ClientTestimonialSlider";
import WaitingForDeserving from "@/components/careers/WatingForDeserving";
import PagesHeader from "@/components/common/PagesHeader";
import Layout from "@/components/layout/Layout";
import axios from "axios";
import { CULTURE_FEATURE_LIST } from "const/careers";
import { API_URL } from "const/common";
import Image from "next/image";

function CareersPage({ data }) {
  return (
    <Layout
      description="Are you searching for job in IT company? - ultroNeous is always in search of talents who are ready to evolve, expand and enhance the knowledge. Apply Now!!"
      title="Job Opportunities in #1 IT Company in Ahmedabad | ultroNeous"
    >
      <PagesHeader
        heading="We create experiences"
        subheading="and turn ideas into reality"
        text="Career"
      />
      <Animation />
      <div className="py-16 px-4 md:px-10 bg-primary-black">
        <p className="text-3xl leading-normal md:text-4xl md:leading-normal font-medium text-white xl:w-1/2 xl:mt-4 mb-14 xl:mb-20">
          <span>
            We have built a culture that fosters an autonomous, happy
            environment where you can expect to grow and learn everyday.
          </span>
        </p>
        <div className="flex md:flex-row flex-wrap xl:pl-96 xl:ml-8">
          {CULTURE_FEATURE_LIST.map((value) => (
            <div className="w-1/2" key={value.image}>
              <div className="my-8 lg:my-16">
                <div className="w-1/5 md:w-fit">
                  <Image
                    height={48}
                    objectFit="contain"
                    src={value.image}
                    title={value.heading}
                    width={value.width}
                    alt={value.alt}
                  />
                </div>
                <p className="text-sm md:text-xl text-white font-medium mt-3 w-11/12">
                  <span>{value.heading}</span>
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
      <WaitingForDeserving data={data} />
      <div className="md:py-16 px-4 md:px-10 bg-primary-black">
        <p className="text-3xl md:text-6xl font-medium text-white text-center pt-16 mb-16 md:mb-4">
          <span>Our Team is our Gem</span>
        </p>
        <ClientTestimonialSlider
          data={data.data1.data}
          forOther={true}
        />
      </div>
      <div className="flex flex-col md:flex-row justify-end items-center">
        <div className="flex w-full md:w-1/2 fs-0">
          <Image
            alt="ultroNeous Team"
            height={1015}
            src={"/assets/careers/careers.webp"}
            width={650}
          />
        </div>
        <div className="w-full md:w-1/2 px-3">
          <div className="py-12 md:px-4 xl:px-20">
            <h2 className="text-3xl leading-normal xl:text-6xl font-medium mb-7 text-primary-black">
              <span>
                Our Catchphrase, <br />
                We say Team,
                <br />
                Team says Client
              </span>
            </h2>
            <p className="text-base leading-loose md:text-lg md:leading-relaxed xl:text-xl text-justify pt-4 md:pt-8 font-normal mb-7 text-primary-black">
              <span>
                ultroNeous believes in giving the highest priority to their
                employees in regards to their Mental, Physical & Emotional
                well-being. This approach innovated ultroGagement, to take care
                of our clients with on-time deliveries of projects, quality
                satisfaction, and clear communication.
              </span>
            </p>
          </div>
        </div>
      </div>
    </Layout>
  );
}
export async function getServerSideProps() {
  const response = await axios.get(`${API_URL}admin/getemployefeedback`, {
    params: { page: 1, limit: 88 },
  });
  const responseJobRequest = await axios.get(
    `${API_URL}admin/getjobrequirements`
  );

  return {
    props: {
      data: {
        data1: response ? response.data : [],
        data2: responseJobRequest ? responseJobRequest.data : undefined,
      },
    },
  };
}
export default CareersPage;
